const productQty = [1, 3, 6];
const defaultPlans = [1, 3, 6];

let products = [];

if (typeof methylated !== 'undefined') {
    console.log('methylated defined');
    if (mainProduct.id == 15479493525873) {
        nonMethylated = formatProducts(mainProduct.variants.filter((prod) => !prod.title.includes("Nutritional")));
        methylated = formatProducts(mainProduct.variants.filter((prod) => prod.title.includes("Nutritional")));
    } else if (!mainProduct.title.toLowerCase().includes('vitamin d3')) {
        // products for peptide growth pack
        console.log('not vit d3');
        nonMethylated = formatProducts(mainProduct.variants.filter((prod) => !prod.title.includes("Women")));
        methylated = formatProducts(mainProduct.variants.filter((prod) => prod.title.includes("Women")));
    } else {
        console.log('vit d3');
        methylated = formatProducts(mainProduct.variants.filter((prod) => prod.options.includes("D3 + K2")));
        nonMethylated = formatProducts(mainProduct.variants.filter((prod) => !prod.options.includes("D3 + K2")));
    }
    products = nonMethylated;
    if (methylated.length === 3) {
        methylated.pop();
    }
    console.log(methylated);
} else {
    products = formatProducts(mainProduct.variants);
    if (products.length > 3) {
        products = products.filter(p => !p.title.toLowerCase().includes('methylated'));
    }
}


if (products.length === 3) {
    products.pop();
}


function formatProducts(variants) {
    return variants.map((prod, index) => {
        prod.price = +((wholeSalePrice[prod.id] ? wholeSalePrice[prod.id] : prod.price) / 100)?.toFixed(2);
        prod.discount_symbol = '%';
        if (mainProduct.selling_plan_groups.length) {
            prod.selling_plan_groups = mainProduct.selling_plan_groups;
            // Subscription price comes from the real selling plan allocation (Recharge), not a hardcoded 15%.
            const defaultPlanId = prod.selling_plan_groups[0].selling_plans[0].id;
            const subAlloc = (prod.selling_plan_allocations || []).find(a => a.selling_plan_id === defaultPlanId) || (prod.selling_plan_allocations || [])[0];
            if (index === 0) {
                prod.discountPrice = subAlloc ? +(prod.price - subAlloc.price / 100).toFixed(2) : prod.price * 0.15;
            } else {
                prod.discountPrice = prod.price;
            }
            prod.discountPrice1 = prod.discountPrice * 100;
            prod.totalDiscountPrice = prod.discountPrice1;
            prod.finalDiscountedPrice = prod.price - prod.discountPrice;
            prod.youSaveMoney = prod.price - prod.finalDiscountedPrice;
            prod.discountPricePerItem = prod.finalDiscountedPrice / productQty[index];
            prod.quntity = productQty[index];
            prod.converted_price = prod.price;
            prod.percentage = prod.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value;
            prod.selectedPlan = defaultPlans[index];
            prod.per_item_price = (prod.converted_price / prod.quntity)?.toFixed(2);
        } else {
            prod.noSub = true;
        }

        return prod;
    });
}


let cleared = false;
const cartBtnTotal = document.querySelectorAll('.cart-amount');
let productPerItem = document.querySelectorAll('.per-bottle');
const formOneTime = document.getElementById('ot-price');
const stickyOneTime = document.getElementById('ot-price-sticky');
const formSubTotal = document.getElementById('sub-price');
const stickySubTotal = document.getElementById('sub-price-sticky');
const subInput = document.getElementById('subscription');
const oneTimeInput = document.getElementById('one-time');
const cartButton = document.querySelectorAll('.cart-btn');
let selectedIndex = 0;
let isSubscription = true;
currencySym = '$';

if (wholeSalePrice[products[0].id]) {
    document.getElementById('sub-element')?.remove();
    isSubscription = false;
}


window.addEventListener('unload', function (event) {
    console.log('Page is being unloaded');
});


function selectFrequency(elem) {
    document.querySelector('.frequency .selected')?.classList.remove('selected');
    document.querySelector('input[id="subscription"]').value = true;
    elem.classList.add('selected');
}


/********************************************
 *
 * Checkout handler
 *
 ********************************************/
function optionClickHandler(elem, index) {
    // The one-time 3-month supply is priced at exactly 3x the single bottle, so it is
    // no longer shown as discounted (no red price, no strikethrough).
    if (index === 1) {
        isSubscription = false;
    }
    document.querySelector('.quantity .selected')?.classList.remove('selected');
    elem.classList?.add('selected');
    selectedIndex = index;
    togglePurchaseOption(true);
}


async function togglePurchaseOption(planChanged = false) {
    // clearCart(false);
    const product = products[selectedIndex];

    if (product.noSub) {
        return;
    }
    const isSub = isSubscription;
    if (subInput) {
        subInput.checked = isSub;
    }
    oneTimeInput.checked = !isSub;
    const totalPrice = (isSub ? product.finalDiscountedPrice : product.converted_price)?.toFixed(2);
    cartBtnTotal.forEach((c) => {
        c.textContent = currencySym + totalPrice;
    });
    formOneTime.textContent = currencySym + product.converted_price.toFixed(2);
    stickyOneTime.textContent = currencySym + product.converted_price.toFixed(2);
    if (formSubTotal) {
        formSubTotal.textContent = currencySym + product.finalDiscountedPrice.toFixed(2);
        stickySubTotal.textContent = currencySym + product.finalDiscountedPrice.toFixed(2);
    }
    if (planChanged) {
        products.forEach((prod, i) => {
            if (productPerItem[i]) {
                productPerItem[i].textContent = currencySym + (((isSub && i === 0) ? +prod.discountPricePerItem : +prod.per_item_price).toFixed(2));
            }
        });
    }


}


// Pages without the old buy box (the v11 hero, which only uses addToCart) have
// no one-time radio, and the call would throw on its first line that needs it.
if (oneTimeInput) togglePurchaseOption(true);

let processing = false;
let cartProcessing = false;

async function addToCart(redirect = false) {
    if (cartProcessing) return;
    const tosElement = document.getElementById('countryTos');
    const tosChecked = tosElement.checked;
    if (!isUS && !tosChecked) {
        document.getElementById('tos-error').classList.add('active');
        document.querySelector('.tos-box').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
        return;
    }
    cartProcessing = true;
    cartButton.forEach(b => b.classList.add('active'));
    let data;


    if (!bundleProducts) {
        const product = products[selectedIndex];
        const frequencyId = document.querySelector('.frequency .selected')?.getAttribute('data-id');
        let selling_plan = !product.noSub ? frequencyId : null;
        if (isSubscription) {
            data = {
                items: [{
                    "id": product.id,
                    "quantity": 1,
                    "selling_plan": selling_plan,
                    "properties": {"_pdp": "alt"}
                }],
                sections: 'cart-section',
            };
        } else {
            data = {

                items: [{
                    "id": product.id,
                    "quantity": 1,
                    "properties": {"_pdp": "alt"}
                }],
                sections: 'cart-section',
            };


        }
    } else {

        data = {
            items: bundleProducts.map(p => {
                const productData = {
                    id: p.variants[0].id,
                    quantity: 1,
                    properties: {_pdp: 'alt'},
                }

                if (isSubscription) {
                    console.log(p);
                    productData['selling_plan'] = p.selling_plan_groups[0].selling_plans[0].id
                }
                return productData
            }),
            attributes: {
                'qsb': mainProduct.title.replace(' Quick Start Bundle', '').replace(' - ', '-').replaceAll(' ', '-'),
            },
            sections: 'cart-section',
        };
    }
    // }

    if (typeof isWholeSale !== 'undefined') {
        data.attributes = {
            'isWholeSeller': true
        };
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(async (response) => {
        const discountedItemCart = await processDiscountData();
        cartProcessing = false;
        vwoAddToCart();
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }

        cartButton.forEach(b => b.classList.remove('active'));
        const body = await response.json();

        if (redirect) {
            location.href = '/checkout';
            return;
        }

        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        updateCartBadge(1);
        addDiscountProduct();
        // document.querySelector('.checkout-btn').scrollIntoView({behavior: 'smooth'});
        // } else {
        // insertRow(body);
        // }
    }).catch((error) => {
        cartProcessing = false;
        cartButton.forEach(b => b.classList.remove('active'));
        console.log(error);
        alert('An error occurred while processing your request. Please try again later.');
    });


    // flyToCart();
}


document.querySelectorAll('.opt-label').forEach((el) => {
    el.addEventListener('click', (e) => {
        document.querySelector('.purchase-option.active')?.classList?.remove('active');
        el.parentElement.classList.add('active');
        isSubscription = el.getAttribute('for') === 'subscription';
        document.querySelector('.sticky-cart').classList.remove('sub-active');
        if (isSubscription) {
            document.querySelector('.sticky-cart').classList.add('sub-active');
            selectedIndex = 0;
        }
        optionClickHandler(document.querySelector('.otp-box'), selectedIndex);
        // togglePurchaseOption(true);
    });
});


/********************************************
 *
 * DHT Pill Popper
 *
 ********************************************/
const closed = document.querySelector('#close-pill');
const open = document.querySelector('#open-pill');
let hasPopped = false;

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.left >= 0 &&
        rect.top >= -400 &&
        (rect.bottom - 100) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

document.addEventListener('scroll', function () {
    return;
    const box = hasPopped ? open : closed;
    if (!hasPopped && isInViewport(box)) {
        hasPopped = true;
        document.querySelector('.product-capsule').classList.add('reverse');
    } else if (hasPopped && !isInViewport(box)) {
        hasPopped = false;
        document.querySelector('.product-capsule').classList.remove('reverse');
    }

}, {
    passive: true
});


/********************************************
 *
 * Mobile Slider Range for DHT products Card
 *
 ********************************************/
let isUS = true;

fetch('https://d43or1ujf2spv.cloudfront.net', {
    method: 'get'
}).then((response) => {
    if (response.status === 403) {
        isUS = false;
        document.querySelector('.tos-box').classList.add('active');
        document.querySelector('.product-form').classList.add('global');
    }
}).catch((err) => {
    console.log(err);
})

function removeTosError() {
    setTimeout(() => {
        if (document.getElementById('countryTos').checked) {
            document.getElementById('tos-error').classList.remove('active');
        }
    }, 500);
}


// Select the target element
const targetElement = document.querySelector('.product-360');


const bottomStrip = document.querySelector('.bottom-strip')
// Callback function for the observer
const observerCallback = (entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            bottomStrip.classList.remove('active');
            console.log('Element appeared in the viewport!');
            // Add any action when the element reappears in the viewport
        } else {
            console.log(entry);
            bottomStrip.classList.add('active');
            console.log('Element disappeared from the viewport!');
            // Add any action when the element disappears from the viewport
        }
    });
};

// Options for the observer
const observerOptions = {
    root: null, // Use the viewport as the root
    threshold: 0, // Trigger when even 1px of the element is visible
};

// Create the observer
const observer = new IntersectionObserver(observerCallback, observerOptions);

// Start observing the target element
if (targetElement) {
    observer.observe(targetElement);
}


function scrollSlide(index, parentClass = '#original-images') {
    if (window.innerWidth < 768) {
        scrollSlideMobile(index);
    }
    document.querySelector(parentClass + ' .p-slides .active')?.classList.remove('active');
    document.querySelector(parentClass + ' .p-slides #img-' + index).classList.add('active');
    document.querySelector(parentClass + ' .thumbnail.active')?.classList?.remove('active');
    document.getElementById(parentClass + ' thumb-' + index)?.classList?.add('active');
}


let currentSlide = 0;

const totalSlides = document.querySelectorAll('.p-slides div').length;

function scrollSlideMobile(index) {
    if (index < 0 || index >= totalSlides) {
        return;
    }
    currentSlide = index;
    if (currentSlide === 0) {
        document.querySelector('.left-arrow').style.display = 'none';
    } else {
        document.querySelector('.left-arrow').style.display = 'block';
    }

    if (currentSlide === totalSlides - 1) {

        document.querySelector('.right-arrow').style.display = 'none';
    } else {
        document.querySelector('.right-arrow').style.display = 'block';
    }

    console.log(currentSlide);
    console.log('#image-container #img-' + index);
    document.querySelector('.p-slides #img-' + index).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
    });
}

function slideNext() {
    scrollSlide(currentSlide - 1);
}

function slidePrev() {
    scrollSlide(currentSlide + 1);
}

document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.results .d-flex');
    const btnLeft = document.querySelector('.nav-btn');
    const btnRight = document.querySelector('.nav-btn.rt');
    const cards = Array.from(container.querySelectorAll('.result-card'));


    let isScrolling = false;

    function updateButtonState() {
        // If the container isn't scrollable horizontally, hide both buttons.
        if (container.scrollWidth <= container.clientWidth) {
            btnLeft.classList.add('d-none');
            btnRight.classList.add('d-none');
            return;
        } else {
            btnLeft.classList.remove('d-none');
            btnRight.classList.remove('d-none');
        }
        // Update active class based on scroll position.
        if (container.scrollLeft <= 0) {
            btnLeft.classList.remove('active');
        } else {
            btnLeft.classList.add('active');
        }
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 1) {
            btnRight.classList.remove('active');
        } else {
            btnRight.classList.add('active');
        }
    }

    // Throttle scroll updates with requestAnimationFrame
    container.addEventListener('scroll', function () {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                updateButtonState();
                isScrolling = false;
            });
            isScrolling = true;
        }
    });

    window.addEventListener('resize', updateButtonState);

    btnRight.addEventListener('click', (e) => {
        e.preventDefault();
        const currentScroll = container.scrollLeft;
        const containerWidth = container.clientWidth;
        // Loop through cards to find the first card whose right edge is beyond the visible area.
        for (let card of cards) {
            const cardLeft = card.offsetLeft;
            const cardRight = cardLeft + card.offsetWidth;
            if (cardRight > currentScroll + containerWidth) {
                // Scroll to the card's left edge
                container.scrollTo({left: cardLeft, behavior: 'smooth'});
                break;
            }
        }
    });

    btnLeft.addEventListener('click', (e) => {
        e.preventDefault();
        const currentScroll = container.scrollLeft;
        // Loop backwards to find the first card that is to the left of the current view.
        for (let i = cards.length - 1; i >= 0; i--) {
            const cardLeft = cards[i].offsetLeft;
            if (cardLeft < currentScroll) {
                container.scrollTo({left: cardLeft, behavior: 'smooth'});
                break;
            }
        }
    });

    // Initial check on load.
    updateButtonState();
});

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.t-tabs .tabs .tab').forEach((el, i) => {
        el.addEventListener('click', (e) => {
            console.log('tab clicked');
            const openedTab = document.querySelector('.t-tabs .tab.active');
            if (openedTab && openedTab !== el) {
                openedTab.classList.remove('active');
            }
            document.querySelector('.tab-contents .tc-container.active').classList.remove('active');
            document.querySelector('.tab-contents .tc-container#tab-' + i).classList.add('active');
            el.classList.add('active');
        });
    });
    document.querySelectorAll('.tab-contents .tab').forEach((el, i) => {
        el.addEventListener('click', (e) => {
            const openedFaq = document.querySelector('.tab-contents.tc-container.active');
            if (openedFaq && openedFaq !== el.parentElement) {
                openedFaq.style.transform = '';
                openedFaq.parentElement.classList.remove('active');
            }

            el.parentElement.classList.toggle('active');
        });
    });
});